// @flow
import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Row} from 'reactstrap';
import { mergeSearch } from '../../redux/actions';
import RiaTypes from '../riaType';

const IndividualRiaType = ({ formName }) => {
    const dispatch = useDispatch();
    const types = useSelector((state) => state.FirstClassData.formStates[formName].formState.ria_types);

    const [ria_types, canAddAnotherriaTypesClause] = useMemo(() => {
        const canAddAnotherriaTypesClause = types.filter(row => {
                    return row.types.length === 0;
                }).length === 0;
        return [types, canAddAnotherriaTypesClause];
    }, [types]);

    const onFieldChange = (event, index) => {
        let riaTypes = ria_types.slice();
        riaTypes[index][event.target.name] = event.target.value;
        riaTypes[index]['label'] = event.target.label;
        dispatch(mergeSearch({ ria_types: riaTypes }, formName));
    };

    const onChange = (event, index) => {
        let riaTypes = ria_types.slice();
        riaTypes[index][event.target.name] = event.target.label;
        riaTypes[index]['riatypes_type_bool'] = event.target.value;
        dispatch(mergeSearch({ ria_types: riaTypes }, formName));
    };

    const handleIncludeExcludeClick = (exclude, index) => {
        let riaTypes = ria_types.slice();
        riaTypes[index].exclude = !exclude;
        dispatch(mergeSearch({ ria_types: riaTypes }, formName));
    };

    const handleDeleteButtonClick = (index) => {
        let riaTypes = ria_types.slice();
        riaTypes.splice(index, 1);
        dispatch(mergeSearch({ ria_types: riaTypes }, formName));
    };

    const handleAddriaTypesClause = () => {
        let riaTypes = ria_types.slice();
        riaTypes.push({
            exclude: false,
            riatypes_type_bool: 'or',
            types: []
        });
        dispatch(mergeSearch({ ria_types: riaTypes }, formName));
    };

    return (
        <Col lg={24}>
            {ria_types.map((riaTypesClause, index) => (
                <Card className="my-1 license-groups-card-border" key={index}>
                    <CardHeader className="bg-light">
                        <a className="link"
                           onClick={() => handleIncludeExcludeClick(riaTypesClause.exclude, index)}
                        >
                            {riaTypesClause.exclude ? 'Exclude' : 'Include'}
                        </a>
                        &nbsp;records matching these RIA Types:

                        {ria_types.length > 1 &&
                        <button
                            onClick={() => handleDeleteButtonClick(index)}
                            type="button"
                            className="close"
                            aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        }
                    </CardHeader>
                    <CardBody className="pt-1">
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>RIA Types</Label>
                                    <RiaTypes name="types" multi={true}
                                                  value={riaTypesClause.types}
                                                  onChange={(event) => onFieldChange(event, index)} />

                                    {riaTypesClause.types.length > 1 &&
                                    <div className="form-inline flex-row-reverse pt-1">
                                        <p>
                                            Search for customers has &nbsp;
                                            <Input type="select"
                                                   name="riatypes_type_bool"
                                                   bsSize="sm"
                                                   value={riaTypesClause.riatypes_type_bool}
                                                   onChange={(event) => onChange(event, index)}>
                                                <option value="and">all of these ria types</option>
                                                <option value="or">any of these ria types</option>
                                            </Input>
                                        </p>
                                    </div>
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            ))}
            {canAddAnotherriaTypesClause && (
                <Button
                    className="p-0 ml-3"
                    color="link"
                    onClick={handleAddriaTypesClause}>
                    + Add another RIA Type clause
                </Button>
            )}
        </Col>
    );
};

export default IndividualRiaType;